module.exports = __webpack_public_path__ + "static/ProblemStatement-HeroImg-a6a3849870f00aa2b145170535c771fb.jpg";